import { FC } from 'react';
import { CgMail } from 'react-icons/cg';
import { Text } from '@chakra-ui/react';

import { WorkflowStepFormFieldInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const EmailFieldToBlock: FieldToBlock<
  'email',
  WorkflowStepFormFieldInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'input',
  componentProps: {
    startElement: <CgMail />,
    type: 'email',
    size: 'sm',
  },
});

type EmailFieldValueProps = FieldValueProps<'email'>;

export const EmailFieldValue: FC<EmailFieldValueProps> = ({ field }) => (
  <Text>{field.value}</Text>
);
